module.exports = __webpack_public_path__ + "img/20_83.62fb483b.png";